// Frans (fr-FR), hallway: het bord in de gang van een gedeelde woning (golf 6b).
export const hallwayFr = {
    thisWeek: 'À qui le tour cette semaine',
    today: 'Aujourd’hui',
    cooks: '{name} cuisine',
    nobody: 'Personne',
    done: 'Fait',
    doneBy: 'Fait par {name}',
    tapHint: 'Touche une tâche quand elle est faite',
    whoDid: 'Qui a fait {duty} ?',
    saved: '{duty} : fait par {name}',
    undo: 'Oups, annuler',
    undone: 'Annulé',
    agenda: 'Agenda de la maison',
    nothingPlanned: 'Rien de prévu',
    close: 'Fermer',
    allDone: 'Tout est fait cette semaine',
    noDuties: 'Pas encore de planning. Crée-le dans l’appli, sous Planning des tâches.',
};
//# sourceMappingURL=hallway.fr.js.map